import "@appretio/ui-kit/theme/global.css";
import { ApiClientProvider } from "@appretio/api";
import { AuthenticationProvider } from "@appretio/auth";
import { TenantProvider } from "@appretio/shared";
import { ErrorBoundary, ThemeProvider, Toast } from "@appretio/ui-kit";
import { QueryClientProvider } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { MockBadge } from "./components/MockBadge";
import {
  type AppErrorToast,
  createAppQueryClient
} from "./createAppQueryClient";
import { isMswActive } from "./mockState";
import { router } from "./routes";
import type { SuccessToast } from "./tanstack-query";

export function App() {
  const [error, setError] = useState<AppErrorToast | null>(null);
  const [success, setSuccess] = useState<SuccessToast | null>(null);

  const queryClient = useMemo(
    () => createAppQueryClient(setError, setSuccess),
    []
  );

  return (
    <ErrorBoundary level="app">
      <AuthenticationProvider>
        <QueryClientProvider client={queryClient}>
          <ApiClientProvider>
            <TenantProvider>
              <ThemeProvider>
                <RouterProvider router={router} />
                <Toast
                  open={!!error}
                  setOpen={() => setError(null)}
                  title={error?.title ?? "Something went wrong"}
                  description={
                    error?.description ?? "An unexpected error occurred."
                  }
                  variant="error"
                  duration={Infinity}
                />
                <Toast
                  open={!!success}
                  setOpen={() => setSuccess(null)}
                  title={success?.title ?? ""}
                  description={success?.description}
                  variant={success?.variant ?? "success"}
                />
                {isMswActive() && <MockBadge />}
              </ThemeProvider>
            </TenantProvider>
          </ApiClientProvider>
        </QueryClientProvider>
      </AuthenticationProvider>
    </ErrorBoundary>
  );
}
